import { render, staticRenderFns } from "./ModuleAccesses.vue?vue&type=template&id=7a395956&"
import script from "./ModuleAccesses.vue?vue&type=script&lang=js&"
export * from "./ModuleAccesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModuleAccesses.vue"
export default component.exports